
<!-- Overlay -->
<div class="position-absolute z-3 w-25 p-3">
  <div class="bg-warning p-3 mb-2 text-center shadow">
    <h3 class="m-0">Live Catches</h3>
  </div>

  <button class="btn btn-light w-100 py-2 mb-2 shadow" routerLink="/add-catch"><i class="fas fa-plus me-2"></i>Create Catch</button>


  <!-- HTML -->
  <div *ngFor="let catch of catchService.catches$ | async" class="card mb-2 border-0 shadow-sm">
    <div class="card-body p-2 d-flex align-items-start">
      <!-- Left: image (flex-shrink 0) -->
      <div class="me-2 flex-shrink-0" style="width:80px;">
        <img *ngIf="catch.image" [src]="(catch.image | getDownloadURL)" alt="catch image" class="img-fluid rounded" style="max-height:80px; object-fit:cover; width:100%;">
      </div>

      <!-- Middle: info -->
      <div class="flex-grow-1">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <div class="small text-muted mb-1">{{catch.time | date: 'HH:mm:ss'}}</div>
            <h6 class="mb-0">{{ catch.catchingTeamName }}</h6>
            <div class="small text-muted">{{ catch.catchingTeamId }}</div>
          </div>

          <!-- Status badge and 3-dot menu -->
          <div class="text-end ms-2">
          <span class="badge"
                [ngClass]="
                  catch.status == CatchStatus.Offline ? 'bg-secondary' :
                  catch.status == CatchStatus.Online  ? 'bg-primary'   :
                  catch.status == CatchStatus.Valid   ? 'bg-success'   : 'bg-danger'
                ">
            {{ catch.status }}
          </span>

            <!-- 3-dot dropdown -->
            <div class="dropdown d-inline-block ms-1">
              <button class="btn btn-sm btn-light p-0 ps-2 pe-2 border" type="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label="More">
                <i class="fas fa-ellipsis-v"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                <li><button class="dropdown-item text-danger"><i class="fas fa-trash-alt me-2"></i>Remove catch</button></li>
                <li><button class="dropdown-item"><i class="fas fa-rocket me-2"></i>Initialise</button></li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Extra details row -->
        <div class="d-flex justify-content-between align-items-center mt-2 small">
          <div>
            <div class="text-muted">Runner</div>
            <div>{{ catch.runningTeamName }} <span class="text-muted">• {{ catch.runningTeamGroup }}</span></div>
          </div>

          <div class="text-end">
            <div class="text-muted">Method</div>
            <div>
              <i class="me-1" [ngClass]="catch.method === 'scan' ? 'fas fa-qrcode text-info' : 'fas fa-hand-paper text-warning'"></i>
              <span class="text-capitalize">{{ catch.method }}</span>
            </div>
          </div>
        </div>

        <!-- Footer: numbers -->
        <div *ngIf="catch.catchNumber" class="d-flex justify-content-between align-items-center mt-2">
          <strong class="text-muted">Number: {{ catch.catchNumber }}</strong>
          <strong class="text-success">Value: {{ catch.catchValue }}</strong>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Map background -->
<div class="vh-100 z-1">
<mgl-map class="h-100 w-100 z-n1"
         [style]="'mapbox://styles/mapbox/outdoors-v12'"
         [attributionControl]="false"
         [zoom]="[13]"
         [center]="[long, lat]">

  <!-- Markers-->
<!--  <mgl-marker [lngLat]="[long, lat]">-->
<!--    <div (click)="alert('Your location.')" class="pin pin-secondary"></div>-->
<!--  </mgl-marker>-->

  <div *ngFor="let catchLoc of (catchesWithLocation$ | async)" (click)="alert('Foo')">
    <mgl-marker [lngLat]="[catchLoc.long, catchLoc.lat]">
      <div [id]="catchLoc.id + '-loc'" class="pin" [class]="catchLoc.status == CatchStatus.Invalid ? 'pin-danger' : catchLoc.status == CatchStatus.Valid ? 'pin-success' : 'pin-warn'"></div>
    </mgl-marker>
  </div>
</mgl-map>
</div>
